import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ModalType =
  'alert' | 'confirm' | 'custom' | 'reward.save' | 'watch.video' | 'leave.video';

export interface ModalProps {
  message?: string;
  [key: string]: unknown;
}

interface UiState {
  modalType: ModalType | null;
  modalProps: ModalProps | null;
  isOpen: boolean;
  /** 직전 라우트. '뒤로가기' 동작 판단에 쓴다. */
  previousPath: string | null;
}

const initialState: UiState = {
  modalType: null,
  modalProps: null,
  isOpen: false,
  previousPath: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<{ type: ModalType; props?: ModalProps }>) => {
      state.modalType = action.payload.type;
      state.modalProps = action.payload.props ?? null;
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.modalType = null;
      state.modalProps = null;
    },
    setPreviousPath: (state, action: PayloadAction<string | null>) => {
      state.previousPath = action.payload;
    },
  },
});

export const { openModal, closeModal, setPreviousPath } = uiSlice.actions;
export default uiSlice.reducer;
